import { render } from "./Pager.vue?vue&type=template&id=da36dc56&lang=pug"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"

import "./Pager.vue?vue&type=style&index=0&id=da36dc56&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__